<template>
  <transition appear name="from-below">
    <v-row class="logo-row-block px-4" align="end" justify="center">
      <v-col class="logo-group px-4 fill-height" cols="12" lg="auto" :style="{width: $vuetify.breakpoint.lgAndUp ? `${groupWidth(i)}%` : null}" v-for="(group, i) in data.logoGroups" :key="i">
        <v-row no-gutters v-if="group.title" class="pb-10 title-container"><div class="d-block text-center title text-no-wrap">{{group.title}}</div></v-row>
        <v-row class="fill-height" align="end" justify="center" no-gutters>
          <v-col cols="12" :lg="Math.round(12 / group.logos.length)" v-for="(logo, k) in group.logos" :key="k" class="justify-center" :class="{'pr-4' : k < group.logos.length - 1}" style="position: relative;">
            <a class="d-flex justify-center" :href="logo.link" rel="noopener" target="_blank" :aria-label="`Sponsor ${k}`" v-if="logo.link">
              <seo-v-img eager :src="optimizedImageURL(logo.image, {maxWidth: 400})" :lazy-src="getLazySrc(logo.image)" width="100%"  />
            </a>
            <div class="d-flex justify-center" v-else>
              <seo-v-img eager :src="optimizedImageURL(logo.image, {maxWidth: 400})" :lazy-src="getLazySrc(logo.image)" width="100%"  />
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </transition>
</template>

<script>
import { optimizedImageURL, getLazySrc, getAspectRatio } from '@/services/OptimizedImage'
export default {
  name: 'ContentLogoRow',
  props: {
    data: {
      type: Object,
      required: true
    },
    full: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    optimizedImageURL,
    getLazySrc,
    getAspectRatio,
    groupWidth (i) {
      let totalLogos = 0
      let groupLogos = 0
      this.data.logoGroups.forEach((g, gi) => {
        g.logos.forEach(l => {
          totalLogos++
          if (gi === i) groupLogos++
        })
      })
      return (100 * groupLogos) / totalLogos
    }
  }
}
</script>

<style lang="scss" scoped>
.logo-group {
  position: relative;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    height: 75%;
    width: 1px;
    @include breakpoint('lg-and-up') {
      background-color: map-get($shades, 'black');
    }
  }

  &:nth-child(1) {
    &::before {
      background-color: transparent;
    }
  }
}

h3 {
  width: 100%;
}

.title {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  font-size: 1rem !important; // https://app.clickup.com/t/acqn97
}

.title-container {
  position: relative;
  height: 1rem;
}
</style>
